import { cn, RawHtml } from '@divlab/divanui';

import useTranslation from '@Queries/useTranslation';
import * as Profile from '@Queries/Profile';
import Button from '@UI/Button';
import styles from './AdditionalRules.module.css';

import type { FC, HTMLAttributes } from 'react';

interface AdditionalRulesProps extends HTMLAttributes<HTMLDivElement> {
  rules: AdditionalRulesData;
}

export type AdditionalRulesData = {
  title: string;
  items: {
    bonus: string;
    text: string;
    image: string;
  }[];
};

const AdditionalRules: FC<AdditionalRulesProps> = (props) => {
  const { className, rules, ...restProps } = props;
  const { t } = useTranslation();
  const profile = Profile.useProfile();
  const button = t('what-you-need');

  return (
    <div className={cn(styles.wrapper, className)} {...restProps}>
      <div className={styles.title}>{rules.title}</div>
      <div className={styles.rules}>
        {rules.items.map((rule) => (
          <div className={styles.rule} key={rule.text}>
            <div className={styles.bonus}>{rule.bonus}</div>
            <RawHtml className={styles.text} html={rule.text} />
            <img className={styles.image} src={rule.image} />
          </div>
        ))}
      </div>
      {!profile.data && (
        <Button className={styles.link} to='/cabinet' theme='transparent' cnButton={styles.button}>
          {button}
        </Button>
      )}
    </div>
  );
};

export default AdditionalRules;
